export default __webpack_public_path__ + "static/media/step_3_dont_1.ec194d96.jpg";